export interface IDataTable {
  [key: string]: string
}
export enum EFilterDate {
  apply = 'apply',
  using = 'using',
}
